module.exports = __webpack_public_path__ + "static/media/pic3.846e8c70.jpg";